import { config } from './runtime';

export const tenantName = config.TENANT_NAME;
export const tenantLogo = config.TENANT_LOGO;
